import { Component } from '@angular/core';
import { ConnectionStatus, NetworkService } from 'src/app/services/network.service';
import { map } from 'rxjs/operators';
import { IonicModule } from '@ionic/angular';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-online-status',
  templateUrl: './online-status.component.html',
  styleUrls: ['./online-status.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
})
export class OnlineStatusComponent {
  online$ = this.networkService.onNetworkChange.pipe(
    map((status) => (status.status === ConnectionStatus.Online ? 'online' : 'offline')),
  );

  constructor(private readonly networkService: NetworkService) {}
}
